import React from 'react';

const LoudSpeaker = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M18.17 4H16.83C15.82 4 15 4.86715 15 5.93522V6.4111L5.5 8.56839V8.02907C5.5 7.59549 5.16 7.23594 4.75 7.23594C4.34 7.23594 4 7.59549 4 8.02907V15.4316C4 15.8651 4.34 16.2247 4.75 16.2247C5.16 16.2247 5.5 15.8651 5.5 15.4316V14.7653L15 16.9226V17.3985C15 18.4666 15.82 19.3337 16.83 19.3337H18.17C19.18 19.3337 20 18.4666 20 17.3985V5.93522C20 4.86715 19.18 4 18.17 4ZM5.5 13.1368V10.1864L15 8.02907V15.2941L5.5 13.1368ZM18.5 17.3985C18.5 17.5889 18.35 17.7475 18.17 17.7475H16.83C16.65 17.7475 16.5 17.5889 16.5 17.3985V5.93522C16.5 5.74487 16.65 5.58625 16.83 5.58625H18.17C18.35 5.58625 18.5 5.74487 18.5 5.93522V17.3985ZM12.97 17.9484C12.7899 18.5467 12.4336 19.0684 11.9533 19.4375C11.473 19.8065 10.8937 20.0036 10.3 19.9999C8.76 19.9999 7.5 18.6887 7.5 17.0918C7.5 16.9755 7.5 16.8486 7.52 16.7323C7.57 16.2987 7.95 15.992 8.36 16.0449C8.77 16.0978 9.06 16.4891 9.01 16.9226V17.0813C9.01 17.8109 9.59 18.4031 10.31 18.4031C10.88 18.4031 11.38 18.0224 11.55 17.462C11.67 17.039 12.1 16.8063 12.49 16.9438C12.89 17.0707 13.1 17.5254 12.98 17.9378L12.97 17.9484Z"
        fill="#7A7A7A"
      />
    </svg>
  );
};

export default LoudSpeaker;